var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    [
      _c("WelcomeModal"),
      _c("div", { staticClass: "footer container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _vm._m(0),
          _c("div", { staticClass: "col-10 col-md-11" }, [
            _c("div", { staticClass: "row height-100" }, [
              _c("div", { staticClass: "col-12 col-lg-3" }, [
                _c("div", { staticClass: "contacts" }, [
                  _c("p", [_vm._v("Gioielleria Italiana Srl")]),
                  _vm._m(1),
                  _c("p", [
                    _c("a", { attrs: { href: "tel:+3901311715646" } }, [
                      _vm._v("01311715646")
                    ]),
                    _c(
                      "a",
                      {
                        staticClass: "d-none d-lg-inline-block social-icon",
                        attrs: {
                          href:
                            "https://instagram.com/amadiamond_official?igshid=MjEwN2IyYWYwYw==",
                          target: "_blank"
                        }
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: ["fab", "instagram"] }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ]),
              _vm._m(2),
              _vm._m(3),
              _c("div", { staticClass: "col-12 col-lg-3 p-0" }, [
                _vm._m(4),
                _c("div", { staticClass: "contacts d-block d-md-none" }, [
                  _c("div", [
                    _c(
                      "a",
                      {
                        staticClass: "social-icon",
                        attrs: {
                          target: "_blank",
                          href:
                            "https://instagram.com/amadiamond_official?igshid=MjEwN2IyYWYwYw=="
                        }
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: ["fab", "instagram"] }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2 col-md-1" }, [
      _c("img", {
        staticClass: "logo",
        attrs: { src: require("../../assets/A_footer.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("a", { attrs: { href: "mailto:info@gioielleriaitaliana.com" } }, [
        _vm._v("info@gioielleriaitaliana.com")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-lg-3 p-0" }, [
      _c("div", { staticClass: "contacts" }, [
        _c("p", [
          _vm._v("Sede Amministrativa"),
          _c("span", { staticClass: "d-none d-lg-inline-block" }, [_vm._v(":")])
        ]),
        _c("p", [_vm._v("Via G. Donizetti, 14")]),
        _c("p", [_vm._v("15048 Valenza (AL) Italia")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-lg-3 p-0" }, [
      _c("div", { staticClass: "contacts" }, [
        _c("p", [
          _vm._v("Sede legale"),
          _c("span", { staticClass: "d-none d-lg-inline-block" }, [_vm._v(":")])
        ]),
        _c("p", [_vm._v("Via Poggio del sole superiore, 1/1")]),
        _c("p", [_vm._v("Albissola Marina (SV) Italia")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contacts" }, [
      _c("p", [
        _vm._v("Responsabile Commerciale"),
        _c("span", { staticClass: "d-none d-lg-inline-block" }, [_vm._v(":")])
      ]),
      _c("p", [_vm._v("Francesco Sette")]),
      _c("p", [
        _c("a", { attrs: { href: "tel:+393493189978" } }, [
          _vm._v("+393493189978")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }